import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import useApp from 'hooks/useApp'
import { Box, LayerBottom, Layer, Button, Scroller } from 'components'
import PopupImgTest from 'images/tmp_popup1.png'
import styles from '../index.module.css'
import Lib from 'library'
import axios from 'axios'
import { SettingIcon, BellIcon } from 'components/HeaderComponents'
import { useNavigate } from 'react-router-dom'
import { atom, useRecoilState, useSetRecoilState, useRecoilValue, useResetRecoilState } from 'recoil'
import { influencerState } from '../states'
import { userState } from 'states'
import { fromState } from 'states'
import Native from 'library/native'
import EventLayer from 'views/setting/EventLayer'
import Notice from 'views/setting/Notice'
import Faq from 'views/setting/Faq'
import EventDetailLayer from 'views/setting/EventDetailLayer'
import { showEventLayerState, showNoticeLayerState, showFaqLayerState, showAlarmLayerState, showAppVerLayerState, showTermsAgreeLayerState, showEventDetailLayerState, showQuestionLayerState, pushDataState } from 'views/setting/states'
import { showSettingState } from 'states/headerState'
import LayerStates from 'states/LayerStates'

const textPopState = atom({
	key: "textPopState",
	default: false
})

const imgPopState = atom({
	key: "imgPopState",
	default: false
})

const openPopState = atom({
	key: "openPopState",
	default: (url, title, id, callback) => {
		if (!url) return
		if (!url.match(/:\/\//)) url = `http://${url}`
		console.log({ url })
		Native.execute("Popup", "openPopup", callback, {
			view_id: id,
			url: url,
			title: title
		})
	}
})

const Home = () => {
	
	const App = useApp()
	const location = useLocation();
	const navigate = useNavigate()
	const mounted = useRef(false)
	const [data, setData] = useState()
	const [showImagePop, setShowImagePop] = useState(false)  // 하단 popup
	// const [bannerFull, setBannerFull] = useState(false)  //  전체 popup
	// const [bannerCenter, setBannerCenter] = useState(false) // 중단 popup
	const [showTextPopup, setShowTextPopup] = useState(false)  // 긴급공지 popup
	const [userInfo, setUserInfo] = useRecoilState(influencerState)   // 인플루언서 가입한 회원정보
	const moneeyUser = useRecoilValue(userState)   // 모니 유저 정보

	const resetFrom = useResetRecoilState(fromState)

	// const [showToast, setShowToast] = useState(false)  // 토스트

	const openPop = useRecoilValue(openPopState)

	// My메뉴 리스트
	const [myMenu, setMyMenu] = useState()

	// 편집하기 상세화면
	const [editShowLayer, setEditShowLayer] = useState(false)
	const [myAllMenu, setMyAllMenu] = useState()

	// 긴급공지 팝업 정보
	const [textPop, setTextPop] = useState()
	const textPopChk = useRecoilValue(textPopState)
	const resetTextPopChk = useResetRecoilState(textPopState)

	// 이미지 팝업 정보
	const [imgPop, setImgPop] = useState()
	const [imgPopChk, setImgPopChk] = useRecoilState(imgPopState)

	// 연동받은 기관이 있는 지 조회한다.
	const [aplyMydata, setAplyMydata] = useState()

	//데이터증명서 리스트
	const [dataCrtfLink, setDataCrtfLink] = useState()

	const [connected, setConnected] = useState()
	const [connectedList, setConnectedList] = useState()

	// 이벤트 리스트
	const [eventList, setEventList] = useState()

	// PUSH 레이어
	const pushData = useRecoilValue(pushDataState);

	const setShowSetting = useSetRecoilState(showSettingState)	//설정
	const [showNoticeLayer, setShowNoticeLayer] = useRecoilState(showNoticeLayerState) //공지사항
	const setShowEventLayer = useSetRecoilState(showEventLayerState) //이벤트
	const setShowFaqLayer = useSetRecoilState(showFaqLayerState) //FAQ

    const [layers, setLayers] = useRecoilState(LayerStates)

	const params = new URLSearchParams(location.search)


	// 쿠키 삭제  - 만기시간을 과거로 되돌리면
	/* const delCookie = (name,value)=> {
		let date = new Date();
		date.setDate(date.getDate() -1 );

		let setCookie = '';
		setCookie += name +  '=' + value+';';
		setCookie += 'Expires=' + date.toUTCString();
		document.cookie = setCookie;  // 쿠키 설정,생성
		alert(name)
	} */

	// 이벤트 리스트 데이터 가져오기
	const getEventData = () => {
		Lib.get(`/api/more/cstmr/srvc/event`, data => {
			//console.log('[배너EVENT] data : ' + JSON.stringify(data));
			setEventList(data)
		})
	}

	// 쿠키 생성
	const setCookie = (name, value) => {
		const today = new Date().getTime()
		const expires = new Date(today + ((1000 * 60 * 60 * 24) * 1)).toUTCString()
		console.log({ expires })
		// let tomorrow = new Date(parseInt(new Date().getTime() / 86400000) * 86400000 + 54000000);
		// console.log({ tomorrow })
		let myCookie = ''
		myCookie += name + '=' + value + ';'
		myCookie += 'expires=' + expires
		document.cookie = myCookie;  // 쿠키 설정,생성
	}

	// 쿠키 확인
	const getCookie = name => {
		if (moneeyUser === undefined) { return false }
		let cookies = document.cookie.split(';')
		if (cookies[0] === '') return true
		let checkCookie = cookies.find(item => {
			if (item.indexOf(name + moneeyUser.mbId) > -1) {
				return true
			} else {
				return false
			}
		})
		return checkCookie ? false : true;
	}

	// 이미지 Layer
	const closeImagePopLayer = () => {
		// 하루동안 안보기 클릭시 cookie 저장
		// 마지막 인자값 숫자는 날자를 지정  0: 오늘하루동안 안보기  3: 3일동안 안보기 7: 일주일동안 안보기
		if (imgPopChk) {
			setCookie('ipc_' + moneeyUser.mbId, 'pop')
		}
		setShowImagePop(false)
	}

	// 긴급공지 Layer
	const closeTextPopLayer = () => {
		// 하루동안 안보기 클릭시 cookie 저장
		// 마지막 인자값 숫자는 날자를 지정  0: 오늘하루동안 안보기  3: 3일동안 안보기 7: 일주일동안 안보기
		if (textPopChk) {
			setCookie('tpc_' + moneeyUser.mbId, 'pop', 0)
		}
		setShowTextPopup(false)
	}

	// 씽크풀 연동 
	const thinkPoolClick = () => {
		// TODO 구글 애널리틱스 테스트 (이벤트 기록)
		Native.execute("Analytics", "logEvent", result => { console.log("logEvent result = " + result) }, {event:"ThinkPool-Click", param: {ITEM_ID: "ThinkPool-Banner", ITEM_NAME: "ThinkPool", CONTENT_TYPE: "banner"}});

		Lib.get(`/api/comm/terms/agree/chk/ctgry/STOCK`,
			data => {
				if(data.termsCtgryAgreeYn==="Y") {
					navigate("/thinkpool/thinkInfo")
				} else {
					navigate("/thinkpool/thinkIntro")
				}
			}
		)
	}

	const inflClick = () => {
		// TODO 구글 애널리틱스 테스트 (이벤트 기록)
		Native.execute("Analytics", "logEvent", result => { console.log("logEvent result = " + result) }, {event:"Influencer-Click", param: {ITEM_ID: "Influencer-Banner", ITEM_NAME: "Influencer", CONTENT_TYPE: "banner"}});

		const inflIntro = window.localStorage.getItem("inflIntro");

		if (inflIntro === null) {
			//navigate("/home/influencerIntro")
			window.localStorage.setItem("inflIntro", true)
		}

		if (userInfo.joinYn === "N") {
			navigate("/home/influencer")
		} else {
			navigate("/home/participate")
		}
	}

	const getPops = () => {
		if (!moneeyUser) return
		Lib.get(`/api/main/chk/popup`, data => {
			//console.log("홈팝업목록[이벤트/팝업] data", JSON.stringify(data));
			if (mounted.current) {
				setImgPop(data.lstImg);
				setShowImagePop(getCookie('ipc_'));
				setTextPop(data.lstTxt);
				setShowTextPopup(getCookie('tpc_'));
			}
		})
	}

	// 초기 header 
	useEffect(() => {
		console.log("HOME으로 이동되었습니다 @@@@@@@@@");
		mounted.current = true
		App.setHeader({
			show: true,
			title: <></>,
			left: null,
			right: <><BellIcon /><SettingIcon /></>,
			type: "transparent"
		})

		App.setShowNav(true)
		App.setMainClass("home pt_0")


		Lib.post(`/api/infl/inf`, { mbId: '' }, data => {
			mounted.current && setUserInfo(data)
		})

		Lib.get(`/api/data/lnkup/chck`, data => {
			//console.log('data : ' + JSON.stringify(data));
			mounted.current && setAplyMydata(data)
		})

		Lib.get(`api/data/crtf/lst/hist?pageNo=1`, data => {
			mounted.current && setDataCrtfLink(data)
		})

		getMyMenu()

		getPops()

		resetFrom()

		getData()

		console.log("home > pushData 확인");
		console.log(pushData);

		window.onBackPress = App.appClose

		console.log("params ::");
		console.log(params.get("push"));

		// if (location.state?.layer) {
		// 	switch(location.state?.layer) {
		// 		case "notice":
		// 			setShowNoticeLayer(true);
		// 			console.log(location.state?.pushNo);
		// 			if (location.state?.pushNo) {
		// 				console.log("pushNo 있음 !!!!");
		// 				// setShowNoticeDetail(true);
		// 				// setNoticeDetailId(location.state.pushNo);
		// 			}

		// 			break;
		// 		case "faq":
		// 			setShowFaqLayer(true);
		// 			break;
		// 		case "event":
		// 			getEventData();
		// 			setShowEventLayer(true);
		// 			break;
		// 		default :
		// 			break;
		// 	}
		// }

		return () => {
			mounted.current = false
			setImgPopChk()
			resetTextPopChk()
			window.onBackPress = App.onBackPress
		}
	}, [])

	useEffect(() => {
		// PUSH Layer 처리
		if (pushData && pushData.url) {
			console.log("푸쉬 데이터가 바뀌는 경우 !!!");
			const urlArr = (pushData.url).split("/");
			if (urlArr[1] === "layer") {
				// layers.map(fn => {
				// 	fn();
				// 	console.log("레이어 닫음12323");
				// });
				// setLayers([]);

				switch(urlArr[2]) {
					case "notice":
						console.log(urlArr[2]);
						setShowNoticeLayer(true);
						break;
					case "faq":
						console.log(urlArr[2]);
						setShowFaqLayer(true);
						break;
					case "event":
						console.log(urlArr[2]);
						// getEventData();
						setShowEventLayer(true);
						break;
					default :
						console.log(urlArr[2]);
						break;
				}
			}
		}
	}, [pushData]);

	// 홈 MY 메뉴 정보
	const getMyMenu = () => {
		Lib.post(`/api/bkm/lst/mb`, {
		}, data => {
			if (!mounted.current) return
			setMyMenu(data)
		})
	}

	// my 편집하기 상세영역 start
	const setCommData = useCallback((data, set) => {
		set(prev => data.filter(function (item) {
			let state = true
			for (var i = 0; i < prev.length; i++) {
				if (item.bkmCd === prev[i].bkmCd) {
					state = false;
				}
			}
			return state;
		}))
	}, [])

	// 편집하기 상세 Layer 정보 가공
	const getMyallMenu = useCallback(async () => {
		await Lib.post(`/api/bkm/lst/mb`, data => setMyAllMenu(data));
		await Lib.post(`/api/bkm/lst/all`, data => setCommData(data, setMyAllMenu));
	}, [])

	// 메뉴 취소하기
	const onMenuDelete = (item) => {
		if (myMenu.length < 5) {
			App.toast('메뉴는 최소4개-최대8개까지 설정 가능합니다.')
			return false
		}
		setMyMenu(prev => prev.filter((el) => {
			return el.bkmCd !== item.bkmCd
		}))
		setMyAllMenu(prev => [...prev, item])
	}

	// 메뉴 등록하기
	const onMenuAdd = (item) => {
		if (myMenu.length > 7) {
			App.toast('메뉴는 최소4개-최대8개까지 설정 가능합니다.')
			return false
		}
		setMyMenu(prev => [...prev, item])
		setMyAllMenu(prev => prev.filter((el) => {
			return el.bkmCd !== item.bkmCd
		}))
	}

	// 설정 초기화
	const resetMenu = () => {
		const resetMenuLst = []
		resetMenuLst.push(
			{
				bkmCd: 'MDATA01',
				sortNo: '1',
				bkmNm: '은행',
				bkmUrl: '/mydata/bankAccount',
				indstCd: "BANK"
			},
			{
				bkmCd: 'MDATA02',
				sortNo: '2',
				bkmNm: '카드',
				bkmUrl: '/mydata/card',
				indstCd: "CARD"
			},
			{
				bkmCd: 'MDATA03',
				sortNo: '3',
				bkmNm: '보험',
				bkmUrl: '/mydata/insurance',
				indstCd: "INSU"
			},
			{
				bkmCd: 'MDATA04',
				sortNo: '4',
				bkmNm: '증권',
				bkmUrl: '/mydata/stock',
				indstCd: "INVEST"
			},
			{
                bkmCd: 'MDATA05',
                sortNo: '5',
                bkmNm: '신용',
                bkmUrl: '/mydata/creditMain',
                indstCd: "CRDT"
            }
		)
		// myMenu()
		setMyMenu(resetMenuLst)
		Lib.post(`/api/bkm/lst/all`, data => {
			setMyAllMenu(data.filter(item => (item.bkmCd !== data[0].bkmCd) && (item.bkmCd !== data[1].bkmCd) && (item.bkmCd !== data[2].bkmCd) && (item.bkmCd !== data[3].bkmCd) && (item.bkmCd !== data[4].bkmCd)))
		});

	}

	// 메뉴 적용하기
	const onAddMenu = () => {
		const choiceMenu = []
		myMenu.forEach((el, index) => {
			choiceMenu.push({
				bkmCd: el.bkmCd,
				sortNo: String(index)
			})
		});
		Lib.post(`/api/bkm/save`, { lstMbBkm: choiceMenu }, data => {
			setEditShowLayer(false)
		})
	}

	// 편집하기 Layer 열기
	const onEditLayer = () => {
		Lib.post(`/api/bkm/lst/mb`, {
		}, data => {
			setMyMenu(data);
		})
		getMyallMenu();
		setEditShowLayer(true)
	}

	// 편집하기 Layer 닫기버튼
    const closeEditMyMenuLayer = () => {
        App.alert({
            msg: "편집한 내용을 적용할까요?",
            ok: "적용하기",
            cancel: "나가기",
            confirm: true,
            type: "bottom",
            onOk: () => {
                onAddMenu();
            },
            onCancel: () => {
                getMyMenu();
                setEditShowLayer(false);
                Lib.post(`/api/bkm/lst/mb`);
            }
        })
    }

	const getData = () => {
		Lib.get("/api/lnkup/data-mgmt-keep", data => {
			if (!mounted.current) return
			setData(data)
		})
	}

	//my메뉴 클릭시 이동
	const openMymenuUrl = (url, cd, indstCd) => {
		console.log({ url })
		console.log({ cd })
		console.log({ indstCd })
		if (cd === "MDATA05") {
			Lib.get(`/api/comm/terms/agree/chk/ctgry/CRDT`,
				data => {
					if (data.termsCtgryAgreeYn === "Y" && data.termsCtgryAgreeDe !== null) {	//신용 연동 o
						navigate("/mydata/creditMain")
					} else {
						navigate("/mydata/creditIntro")
					}
				}
			)
		} else {
			//연동 안되어있으면 데이터 연결화면으로이동
			let found = data.find(item => item.indstCd === indstCd.toLowerCase())
			//console.log("found : " + JSON.stringify(found));
			if (found) {
				navigate(url, {
					state: {
						from: "/home"
					}
				})
			} else {
			    //IRP일 경우 일단 은행이 선택되게 수정
			    if(indstCd == 'IRP') indstCd = "BANK";
			    
			    navigate("/data", {
                    state: {
                        preIndstCd: indstCd
                    }
                });
			}
		}
	}

	//연동 정보
	useEffect(() => {
		if (!data) return
		const newList = []
		const cMap = {}

		data.forEach(item => {
			let found = newList.find(row => row.indstCd === item.indstCd)
			if (!found) {
				found = {
					indstCd: item.indstCd,
					indstNm: item.indstNm,
					data: []
				}
				newList.push(found)
				cMap[item.indstCd] = 0
			}
			found.data.push(item)
			cMap[item.indstCd] = cMap[item.indstCd] + 1
		})
		setConnected(cMap)
		setConnectedList(newList)
	}, [data])

	return (
		<div className="page">
			<div className={styles["main-visual"]}>
				<div className={styles["tit-wrap"]}>
					<div className={styles.title}>
						<span className={styles.tag}>NEW</span>
						<p className="mt_10">오늘은 또 무슨일이?</p>
						<h2>Daily 리포트 </h2>
					</div>
					{/*
					<Link to={aplyMydata && aplyMydata.hasLnkupData ? "/home/report" : "/home/reportIntro"} className="btn-link btn--gradient mt_30">보러가기<><i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></></Link>
					*/}
					<Link to="" className="btn-link btn--gradient mt_30" 
						onClick={(e) => {
							e.preventDefault();
							const today = new Date();
							const hh = ("0" + today.getHours()).slice(-2);
							const mm = ("0" + today.getMinutes()).slice(-2);
							if ((Number(hh) >= 23 && Number(mm) >= 30) || (Number(hh) <= 0 && Number(mm) <= 30)) {
								App.showAlert({
									title: "시스템 정기점검 안내",
									msg: "매일 23:30~00:30분까지는 시스템 점검으로<br />데이터 연동이 불가능합니다.",
									type: "bottom",
									confirm: false,
									onOk() {
										//navigate('/home', {replace: true})
									}
								})
							} else {
								if (aplyMydata && aplyMydata.hasLnkupData) {
									navigate("/home/report");
								} else {
									navigate("/home/reportIntro");
								}
							}
						}}>보러가기<><i className="icon icon_btn_arrow_white ml_5" style={{ marginTop: "-0.3rem" }} /></>
					</Link>
				</div>
				<div className={styles["home-object"]} />
			</div>
			<div className={`${styles["home-title"]} mt_20 padding`}>
				<div className="flex-align_center">
					<h3>MY 메뉴</h3>
					<span className="ml_10">* {myMenu && myMenu.length}개의 정보가 있습니다.</span>
				</div>
				<div className={styles["edit-btn"]} onClick={() => onEditLayer()}>+ 편집하기</div>
			</div>

			{/* my메뉴 최소4개 최대8개 노출 / 4개일때 이상일 때 두가지 타입 */}
			{/* 4개 초과 */}
			{myMenu ?
				<>
					<div className="slider slider-scroll no-scroll">
						<ul className="my-menu pl_20 pr_20">
							{myMenu.length > 4 ? myMenu.map((item, index) => {
								const cd = item.bkmCd.substr(5)
								return (
									<li key={index}>
										<div className="box" onClick={() => openMymenuUrl(item.bkmUrl, item.bkmCd, item.indstCd)}>
											<span>{item.bkmNm}</span>
											<><i className={`icon icon_menu ${styles.icon_menu} ss${cd}`} /></>
										</div>
									</li>
								)
							}) : ''}
						</ul>
					</div>
					{/* 4개 */}
					{myMenu.length <= 4 && (
						<div className="slider slider-normal">
							<ul className="my-menu px_20 pb_10">
								{myMenu.map((item, index) => {
									const cd = item.bkmCd.substr(5)
									return (
										<li key={index}>
											<div className="box" onClick={() => openMymenuUrl(item.bkmUrl, item.bkmCd, item.indstCd)}>
												<span>{item.bkmNm}</span>
												<span className={`icon icon_menu ${styles.icon_menu} ss${cd}`} />
											</div>
										</li>
									)
								})}
							</ul>
						</div>
					)
					}
				</>
				:
				<>
					<div className="slider slider-scroll no-scroll">
						<ul className="my-menu pl_20 pr_20">
							<li style={{ width: "48%", border: "none", borderRadius: "3rem" }} className="skeleton">
								<div className="box" style={{ background: "none", border: "none", boxShadow: "none" }} />
							</li>
							<li style={{ width: "48%", border: "none", borderRadius: "3rem" }} className="skeleton">
								<div className="box" style={{ background: "none", border: "none", boxShadow: "none" }} />
							</li>
							<li style={{ width: "48%", border: "none", borderRadius: "3rem" }} className="skeleton">
								<div className="box" style={{ background: "none", border: "none", boxShadow: "none" }} />
							</li>
							<li style={{ width: "48%", border: "none", borderRadius: "3rem" }} className="skeleton">
								<div className="box" style={{ background: "none", border: "none", boxShadow: "none" }} />
							</li>
						</ul>
					</div>
				</>
			}

			<div className="padding">

				{/* 씽크풀 배너 */}
				<Box className={styles.banner} style={{ background: "#7e5ae2" }} onClick={() => thinkPoolClick()}>
					<div className="flex-column align_end">
						<h3 style={{ letterSpacing: 0 }}>My Stock Manager</h3>
						<span className="mt_5">AI가 알려주는 내 종목 분석으로<br />성공투자 하세요!</span>
					</div>
					<div className={styles["object-group"]} style={{ left: "1rem", right: "auto" }}>
						<span className="icon icon_thinkpool_object" />
					</div>
				</Box>
				
				{/* 인플루언서 배너 */}

				{/* <Link to={`${userInfo && userInfo.joinYn === 'N' ? '/home/influencer' : '/home/participate'}`}> */}
				<Box className={`${styles.banner} mt_20`} onClick={() => inflClick()}>
					<h3>금융인플루언서</h3>
					<span className="mt_5">관심있는 포트폴리오 구독하고,<br />서로의 금융생활을 비교해보세요.</span>
					<div className={styles["object-group"]}>
						<span className="icon icon_influencer_object" />
					</div>
				</Box>
				{/* </Link> */}

				<div className="banner-wrap mt_20">
					<Box onClick={() => {
						const today = new Date();
						const hh = ("0" + today.getHours()).slice(-2);
						const mm = ("0" + today.getMinutes()).slice(-2);
						if ((Number(hh) >= 23 && Number(mm) >= 30) || (Number(hh) <= 0 && Number(mm) <= 30)) {
							App.showAlert({
								title: "시스템 정기점검 안내",
								msg: "매일 23:30~00:30분까지는 시스템 점검으로<br />데이터 연동이 불가능합니다.",
								type: "bottom",
								confirm: false,
								onOk() {
									//navigate('/home', {replace: true})
								}
							})
						} else {
							navigate(dataCrtfLink && dataCrtfLink.length === 0 ? "/home/dataIntro" : "/home/dataList")
						}
					}}>
						<p>데이터 증명서</p>
						<span>내 금융 정보를<br />간편하게 공유해보세요.</span>
						<span className="box-deco" />
						<span className="icon icon_banner_data" />
					</Box>
					{/*
					<Box>
						<Link to={`/home/carIntro`}>
							<p>자동차 시세 비교</p>
							<span>지금 지나가는 저차,<br />시세 바로 확인!</span>
							<span className="box-deco" />
							<span className="icon icon_banner_car" />
						</Link>
					</Box>
					*/}
				</div>

				<BannerBottom show={showImagePop} closeLayer={closeImagePopLayer} closeButton={false} imgPop={imgPop} />
				{/* <BannerFull show={bannerFull} />
				<BannerCenter show={bannerCenter} /> */}
				<TextPopup show={showTextPopup} closeLayer={closeTextPopLayer} textPop={textPop} />
				<EditMyMenuLayer show={editShowLayer} closeLayer={closeEditMyMenuLayer} resetMenu={resetMenu} myMenu={myMenu} myAllMenu={myAllMenu} onMenuAdd={onMenuAdd} onAddMenu={onAddMenu} onMenuDelete={onMenuDelete} />
				<Faq />
				<Notice />
				<EventLayer eventss={eventList}/>
			</div>
		</div>
	)
}

// layer popup

// 팝업 등록 시 '하단'
const BannerBottom = ({ show, closeLayer, closeButton, imgPop }) => {

	const [checked, setChecked] = useRecoilState(imgPopState)
	const openPop = useRecoilValue(openPopState)

	// 이벤트 팝업 정보
	const [eventList, setEventList] = useState()
	const [eventDetail, setEventDetail] = useState()
	const [showEventLayer, setShowEventLayer] = useRecoilState(showEventLayerState)
	const setShowEventDetailLayerState = useSetRecoilState(showEventDetailLayerState)

	// 공지 팝업 정보
	const [detailId, setDetailId] = useState()
	const [showDetail, setShowDetail] = useState(false)
	
	// 이벤트 리스트 데이터 가져오기
	const getData = () => {
		Lib.get(`/api/more/cstmr/srvc/event`, data => {
			//console.log('data : ' + JSON.stringify(data))
			setEventList(data)
			setShowEventLayer(true);
		})
	}

	// 이벤트 배너 디테일 화면
	const getDataEventDetail = (id) => {
		Lib.get(`/api/more/cstmr/srvc/event/${id}`, data => {
			setEventDetail(data)
			setShowEventDetailLayerState(true)
		})
	}

	// 공지사항 배너 디테일 화면
	const getDataNotiDetail = (id) => {
		//console.log('id : ', id);
		setDetailId(id)
		setShowDetail(true)
	}

	const openWebview = url => {
		Native.execute("AppManager", "openScheme", () => { }, {
			url: url
		})
	}

	if (imgPop && imgPop.length === 0) { return false }
	return (
		<>
			<LayerBottom show={show} closeLayer={closeLayer} closeButton={closeButton}>
				{imgPop && imgPop.length === 1 ?
					<div className="slider">
						<ul>
							<li>
								<div className="img-box popup-banner" onClick={() => {
									//openPop(imgPop[0].linkUrl, imgPop[0].operTitle, "imgPop_0")
									closeLayer();
									if (imgPop[0].linkTpCd === "EVENT") {
										//getData();							// 1.이벤트목록
										getDataEventDetail(imgPop[0].linkUrl);	// 2.이벤트상세
									} else if (imgPop[0].linkTpCd === "NOTI") {
										getDataNotiDetail(imgPop[0].linkUrl);	// 1.공지상세
									} else {
										openWebview(imgPop[0].linkUrl);
									}
								}}>
									<img src={`/api/comm/showImage/${imgPop[0].sstmFileId}`} alt="" />
								</div>
							</li>
						</ul>
					</div>
					:
					<div className="slider">
						<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle} style={{ borderRadius: "3rem" }}>
							{imgPop && imgPop.map((item, index) => {
								return (
									<li key={index} style={{ marginRight: "2rem" }}>
										<div className="img-box popup-banner" onClick={() => {
											//openPop(item.linkUrl, item.operTitle, `imgPop_${index}`)
											//closeLayer();
											if (item.linkTpCd === "EVENT") {
												//getData();						// 1.이벤트목록
												getDataEventDetail(item.linkUrl);	// 2.이벤트상세
											} else if (item.linkTpCd === "NOTI") {
												getDataNotiDetail(item.linkUrl);	// 1.공지상세
											} else {
												openWebview(item.linkUrl);
											}
										}}>
											<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
										</div>
									</li>
								)
							})}
						</Scroller>
					</div>
				}
				<div className="flex-justify_between align_center mt_30">
					<div className="chk" onClick={e => {
						setChecked(prev => !prev)
					}}>
						<span className={`checkMark${checked ? " on" : ""}`} />
						<label>
							<span>하루동안 보지 않기</span>
						</label>
					</div>
					<span onClick={() => closeLayer()}>닫기</span>
				</div>
			</LayerBottom>

			{/*	이벤트 팝업 레이어 추가 */}
			<EventLayer eventss={eventList} />	
			<EventDetailLayer eventDetail={eventDetail} />

			{/* 공지사항*/}		
			<NoticeDetail show={showDetail} closeLayer={setShowDetail} id={detailId} />
		</>
	)
}

//공지사항 상세 화면
const NoticeDetail = (props) => {

	const [data, setData] = useState()

	const getDetail = () => {
		Lib.get(`/api/more/cstmr/srvc/ntc/${props.id}`, data => {
			console.log('data ' + JSON.stringify(data));
			setData(data)
		})
	}

	useEffect(() => {
		props.show && getDetail()
		return () => setData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.show])

	// 다운로드
    const downloadFile = async (fileId, fileNm) => {
		let ext = "";
		let mimeType = "";

        if (fileNm && (fileNm.split(".")).length > 0) {
            ext = (fileNm.split("."))[1];
			mimeType = `application/${ext.toLowerCase()}`
        }

		console.log("fileNm : " + fileNm);
		console.log("mimeType : " + mimeType);

		if(Native.getUserAgent() === "android") {
			Native.execute('AppManager', 'downloadFile', undefined, { url: window.location.protocol + "//" + window.location.host+'/api/comm/download/' + fileId, filename:fileNm, mimeType:mimeType});
		} else if(Native.getUserAgent() === "ios") {
			Native.execute('AppManager', 'sharePlus', undefined, { type:'url', data:window.location.protocol + "//" + window.location.host +'/api/comm/download/' + fileId, filename:fileNm});
		}

		// const options = {
		// 	method: "GET",
		// 	responseType: "arraybuffer",
		// 	headers: {},
		// 	data: {},
		// 	url: `/api/comm/download/${fileId}`,
		// 	maxContentLength: Infinity,
		// 	maxBodyLength: Infinity,
		// 	timeout: 60 * 30 * 1000,
		// 	cache: "no-cache"
		// };

		// await axios(options)
		// .then(function(response) {
		// 	console.log(response);
		// 	const url = window.URL.createObjectURL(
		// 		new Blob([response.data], {type: `${mimeType}`})
		// 	);
		// 	Lib.reqBlobFileDownlaod(url,fileNm);
		// 	setTimeout(() => {
		// 		window.URL.revokeObjectURL(url);
		// 	}, 1000);
		// })
		// .then(function() {
		// 	console.log("success");
		// })
		// .catch(function(error) {
		// 	console.log("fail");
		// });
    }

	return (
		<Layer {...props} >
			{data ?
				<div className="page padding">
					<div className={styles["detail-title"]}>
						<p>{data.notiTitle}</p>
						<span>{data.notiStDe}</span>
					</div>
					<hr className="my_30" />
					<div className={styles["detail-content"]}>
						<p className="section-cont" dangerouslySetInnerHTML={{ __html: data.notiConts }}></p>
						{/*	[공지상세에서 첨부이미지 삭제. 20230128]
						{
							data.atchFileList &&
							data.atchFileList.length && data.atchFileList.map((img, index) => {
								return (
									<div key={index} className="img-box mt_20">
										<img src={`/api/comm/showImage/${img.sstmFileId}`} className="bbs_img" alt={img.orignFileNm} />
									</div>
								)
							})
						}
						*/}
						<div className="img-box mt_20">
							{data.atchFileList && 
								data.atchFileList.map((img, index) => {
									return (
										<button type="button" className="btn" onClick={() => downloadFile(img.sstmFileId, img.orignFileNm)}>
											{`${img.orignFileNm} 파일 다운로드`}
										</button>
									)
								})
							}
						</div>	
					</div>
				</div>
				:
				<div className="page padding">
					<div className="skeleton" style={{ width: "20rem", height: "2rem" }}></div>
					<div className="skeleton mt_10" style={{ width: "10rem", height: "2rem" }}></div>
					<hr className="my_20" />
					<p className="skeleton" style={{ height: "15rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
				</div>
			}
		</Layer>
	)
}

// 팝업 등록 시 '전면'
/* const BannerFull = ({show}) => {
	if (show === false) return false;
	return (
		<Portal>
			<div className="banner-layer">
				<div className="full">
					<div className="slider flex_1">
						<ul>
							<li>
								<div className="img-box">
									<img src={LandingImg} alt="" />
								</div>
							</li>
						</ul>
					</div>
					<div className="padding flex_shrink_0">
						<ul className="slider-dots popup-slider-dots">
							<li className="active" />
							<li />
							<li />
						</ul>
						<div className="flex-justify_between align_center mt_30">
							<div className="chk">
								<input type="checkbox" id="check2" name="state" />
								<label htmlFor="check2">
									<span>24시간동안 보지 않기</span>
								</label>
							</div>
							<span>닫기</span>
						</div>
					</div>
				</div>
			</div>
		</Portal>
	)
} */

// 팝업 등록 시 '중간'
/* const BannerCenter = ({show}) => {
	if (show === false) return false;
	return (
		<Portal>
			<div className="banner-layer">
				<div className="dim" />
				<div className="center">
					<div className="slider">
						<ul>
							<li>
								<div className="img-box popup-banner">
									<img src={PopupImgTest} alt="" />
								</div>
							</li>
						</ul>
						<ul className="slider-dots popup-slider-dots mt_20">
							<li className="active" />
							<li />
							<li />
						</ul>
					</div>

					<div className="flex-justify_between align_center mt_30">
						<div className="chk">
							<input type="checkbox" id="check3" name="state" />
							<label htmlFor="check3">
								<span>하루동안 보지 않기</span>
							</label>
						</div>
						<span>닫기</span>
					</div>
				</div>
			</div>
		</Portal>
	)
} */

const TextPopup = ({ show, closeLayer, textPop }) => {

	const [checked, setChecked] = useRecoilState(textPopState)
	const openPop = useRecoilValue(openPopState)

	if (textPop && textPop.length === 0) { return false }
	return (
		<LayerBottom show={show} closeLayer={closeLayer}>
			{textPop && textPop.length === 1 ?
				<div className="slider">
					<ul>
						<li onClick={() => {
							openPop(textPop[0].linkUrl, textPop[0].operTitle, "textPop_0")
						}}>
							<div className="popup-text">
								<p className="title">ㅤ </p>
								<div className="mt_15" style={{ minHeight: "10rem" }}>
									<p className="section-cont" dangerouslySetInnerHTML={{ __html: textPop[0].operConts }}></p>
								</div>
							</div>
						</li>
					</ul>
				</div>
				:
				<div className="slider">
					<ul>
						<li>
							<div className="popup-text">
								<p className="title">ㅤ </p>
								<Scroller dotsStyle={styles.dotsStyle} dotStyle={styles.dotStyle} activeDotStyle={styles.activeDotStyle}>
									{textPop && textPop.map((item, index) => {
										return (
											<li key={index} className="mt_15" style={{ minHeight: "10rem", width: "100%" }} onClick={() => {
												openPop(item.linkUrl, item.operTitle, `textPop_${index}`)
											}}>
												<p className="section-cont" dangerouslySetInnerHTML={{ __html: item.operConts }}></p>
											</li>
										)
									})}
								</Scroller>
							</div>
						</li>
					</ul>
				</div>
			}
			<div className="flex-justify_between align_center mt_30">
				<div className="chk" onClick={e => {
					setChecked(prev => !prev)
				}}>
					<span className={`checkMark${checked ? " on" : ""}`} />
					<label>
						<span>하루동안 보지 않기</span>
					</label>
				</div>
				<span onClick={closeLayer}>닫기</span>
			</div>
		</LayerBottom>
	)
}

const EditMyMenuLayer = ({ show, closeLayer, resetMenu, myMenu, myAllMenu, onMenuAdd, onAddMenu, onMenuDelete }) => {
	return (
		<Layer title={'편집하기'} show={show} closeLayer={closeLayer}>
			<div className="page pb_100">
				<div className="flex_1">
					<div className="shadow">
						<div className="padding pt_30 pb_40">
							<div className={styles["edit-tit"]}>
								<p>MY메뉴 순서를<br />변경해보세요!</p>
								<span onClick={() => resetMenu()} className="flex-align_center"><span className="icon icon_refresh mr_5" />설정 초기화</span>
							</div>
							<span className={`${styles.guide} mt_20`}>* 최소 4개 이상 최대 8개까지 설정이 가능해요!</span>
							<ul className={`${styles["edit-group"]} mt_15`}>
								{myMenu && myMenu.map((item, index) => {
								    if (item.indstCd === 'CAPITAL' || item.indstCd === 'GINSU' || item.indstCd === 'BOND' || item.indstCd === 'P2P') {
                                        /* 20221024 개발일정에 따른 업무범위 축소로 해당 메뉴 제외 */
                                        return null
                                    }
                                    else {
                                        return (
                                            <li key={index}>{item.bkmNm} <span className="icon icon_edit_close" onClick={() => onMenuDelete(item)} /></li>
                                        )
                                    }
//									return (
//										<li key={index}>{item.bkmNm} <span className="icon icon_edit_close" onClick={() => onMenuDelete(item)} /></li>
//									)
								    })
						        }
							</ul>
						</div>
					</div>
					<div className="padding">
						<div className={`${styles["edit-tit"]} mt_10`}>
							<p>자주 이용하는<br />메뉴를 더 골라보세요.</p>
						</div>

						<h3 className={`${styles.sTitle} mt_40`}>마이데이터</h3>
						<ul className={`${styles["edit-group"]} ${styles.gray} mt_10`}>
							{myAllMenu && myAllMenu.map((item, index) => {
								if (item.ctgryCd === 'BKM_LIFE') {
									return null
								}
								else if (item.indstCd === 'CAPITAL' || item.indstCd === 'GINSU' || item.indstCd === 'BOND' || item.indstCd === 'P2P') {
								    /* 20221024 개발일정에 따른 업무범위 축소로 해당 메뉴 제외 */
                                    return null
								}
								else {
									return (
										<li key={index} onClick={() => onMenuAdd(item)}>{item.bkmNm}</li>
									)
								}
							})}
						</ul>
						{/* 개발일정에 따른 업무범위 축소로 임시 주석 */}
						{/* <h3 className={`${styles.sTitle} mt_40`}>라이프</h3>
						<ul className={`${styles["edit-group"]} ${styles.gray} mt_10`}>
							{myAllMenu && myAllMenu.map((item, index) => {
								if (item.ctgryCd === 'BKM_MDATA') {
									return null
								} else {
									return (
										<li key={index} onClick={() => onMenuAdd(item)}>{item.bkmNm}</li>
									)
								}
							})}
						</ul> */}
					</div>
				</div>
				<div className="padding flex-shrink_0 btn--fixed" onClick={onAddMenu}>
					<Button className="btn btn--big">적용하기</Button>
				</div>
				{/* <ConfirmLayer show={showLayer} closeLayer={closeLayer} /> */}
			</div>
		</Layer>
	)
}

export default Home
